import axios from 'axios';

import apiConfig from '../api.config';

export default function createBooking({
  hotelId,
  startDate,
  endDate,
  code,
  status = 'uncompleted',
  rooms,
  holderData,
  guestData,
}) {
  const {
    host,
    URIs: { createBooking },
  } = apiConfig;

  const uri = `${host}${createBooking}`.replace(':hotelId', hotelId);

  return axios
    .post(uri, JSON.stringify({ startDate, endDate, code, status, rooms, holderData, guestData }), {
      headers: { 'Content-Type': 'application/json' },
    })
    .then(res => res.data);
}
